const Algo1Module = {
  namespaced: true,
  state: {
    questions: {
      question1: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question2: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question3: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question4: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question5: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question6: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question7: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question8: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
    },
    result: "",
    arrow: false,
  },
  getters: {
    getArrow(state) {
      return state.arrow;
    },
    getMyQuestions(state) {
      return state.questions;
    },
    getResult(state) {
      return state.result;
    },
    getClickedYesQuest1(state) {
      return state.questions.question1.clickedYes;
    },
    getClickedNoQuest1(state) {
      return state.questions.question1.clickedNo;
    },
    getClickedYesQuest2(state) {
      return state.questions.question2.clickedYes;
    },
    getClickedNoQuest2(state) {
      return state.questions.question2.clickedNo;
    },
    getClickedYesQuest3(state) {
      return state.questions.question3.clickedYes;
    },
    getClickedNoQuest3(state) {
      return state.questions.question3.clickedNo;
    },
    getClickedYesQuest4(state) {
      return state.questions.question4.clickedYes;
    },
    getClickedNoQuest4(state) {
      return state.questions.question4.clickedNo;
    },
    getClickedYesQuest5(state) {
      return state.questions.question5.clickedYes;
    },
    getClickedNoQuest5(state) {
      return state.questions.question5.clickedNo;
    },
    getClickedYesQuest6(state) {
      return state.questions.question6.clickedYes;
    },
    getClickedNoQuest6(state) {
      return state.questions.question6.clickedNo;
    },
    getClickedYesQuest7(state) {
      return state.questions.question7.clickedYes;
    },
    getClickedNoQuest7(state) {
      return state.questions.question7.clickedNo;
    },
    getClickedYesQuest8(state) {
      return state.questions.question8.clickedYes;
    },
    getClickedNoQuest8(state) {
      return state.questions.question8.clickedNo;
    },
  },
  actions: {
    sendYesQuestion1({ commit }, value) {
      commit("SEND_YES_QUESTION1", value);
      commit("ANALYZE_QUESTION1");
    },
    sendNoQuestion1({ commit }, value) {
      commit("SEND_NO_QUESTION1", value);
      commit("ANALYZE_QUESTION1");
    },
    sendYesQuestion2({ commit }, value) {
      commit("SEND_YES_QUESTION2", value);
      commit("ANALYZE_QUESTION2");
    },
    sendNoQuestion2({ commit }, value) {
      commit("SEND_NO_QUESTION2", value);
      commit("ANALYZE_QUESTION2");
    },
    sendYesQuestion3({ commit }, value) {
      commit("SEND_YES_QUESTION3", value);
      commit("ANALYZE_QUESTION3");
    },
    sendNoQuestion3({ commit }, value) {
      commit("SEND_NO_QUESTION3", value);
      commit("ANALYZE_QUESTION3");
    },
    sendYesQuestion4({ commit }, value) {
      commit("SEND_YES_QUESTION4", value);
      commit("ANALYZE_QUESTION4");
    },
    sendNoQuestion4({ commit }, value) {
      commit("SEND_NO_QUESTION4", value);
      commit("ANALYZE_QUESTION4");
    },
    sendYesQuestion5({ commit }, value) {
      commit("SEND_YES_QUESTION5", value);
      commit("ANALYZE_QUESTION5");
    },
    sendNoQuestion5({ commit }, value) {
      commit("SEND_NO_QUESTION5", value);
      commit("ANALYZE_QUESTION5");
    },
    sendYesQuestion6({ commit }, value) {
      commit("SEND_YES_QUESTION6", value);
      commit("ANALYZE_QUESTION6");
    },
    sendNoQuestion6({ commit }, value) {
      commit("SEND_NO_QUESTION6", value);
      commit("ANALYZE_QUESTION6");
    },
    sendYesQuestion7({ commit }, value) {
      commit("SEND_YES_QUESTION7", value);
      commit("ANALYZE_QUESTION7");
    },
    sendNoQuestion7({ commit }, value) {
      commit("SEND_NO_QUESTION7", value);
      commit("ANALYZE_QUESTION7");
    },
    sendYesQuestion8({ commit }, value) {
      commit("SEND_YES_QUESTION8", value);
      commit("ANALYZE_QUESTION8");
    },
    sendNoQuestion8({ commit }, value) {
      commit("SEND_NO_QUESTION8", value);
      commit("ANALYZE_QUESTION8");
    },
    clearState({ commit }) {
      commit("RESET_STATE");
    },
    arrowFunction({ commit }) {
      commit("ARROW_TRUE");
    },
    resetArrow({ commit }) {
      commit("ARROW_FALSE");
    },
  },
  mutations: {
    SEND_YES_QUESTION1(state, data) {
      if (state.questions.question1.value === "NO") {
        state.questions.question1.value = data;
        state.questions.question2.question = "";
        state.questions.question2.span = "";
        state.questions.question2.value = "";
        state.questions.question2.clickedYes = false;
        state.questions.question2.clickedNo = false;
        state.questions.question3.question = "";
        state.questions.question3.span = "";
        state.questions.question3.value = "";
        state.questions.question3.clickedYes = false;
        state.questions.question3.clickedNo = false;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question1.clickedMoins = true;
        state.questions.question1.clickedPlus = false;
        state.questions.question1.disabled = true;
      }
      state.questions.question1.value = data;
      state.questions.question1.clickedYes = true;
      state.questions.question1.clickedNo = false;
      state.questions.question1.disabled = true;
    },
    SEND_NO_QUESTION1(state, data) {
      if (state.questions.question1.value === "YES") {
        state.questions.question1.value = data;
        state.questions.question2.question = "";
        state.questions.question2.value = "";
        state.questions.question2.span = "";
        state.questions.question2.clickedYes = false;
        state.questions.question2.clickedNo = false;
        state.questions.question3.question = "";
        state.questions.question3.span = "";
        state.questions.question3.value = "";
        state.questions.question3.clickedYes = false;
        state.questions.question3.clickedNo = false;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question1.clickedNo = true;
        state.questions.question1.clickedYes = false;
        state.questions.question1.disabled = true;
      }
      state.questions.question1.value = data;
      state.questions.question1.clickedNo = true;
      state.questions.question1.clickedYes = false;
      state.questions.question1.disabled = true;
    },
    SEND_YES_QUESTION2(state, data) {
      if (state.questions.question2.value === "NO") {
        state.questions.question2.value = data;
        state.questions.question3.question = "";
        state.questions.question3.span = "";
        state.questions.question3.value = "";
        state.questions.question3.clickedYes = false;
        state.questions.question3.clickedNo = false;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question2.clickedYes = true;
        state.questions.question2.clickedNo = false;
        state.questions.question2.disabled = true;
      }
      state.questions.question2.value = data;
      state.questions.question2.clickedYes = true;
      state.questions.question2.clickedNo = false;
      state.questions.question2.disabled = true;
    },
    SEND_NO_QUESTION2(state, data) {
      if (state.questions.question2.value === "YES") {
        state.questions.question2.value = data;
        state.questions.question3.question = "";
        state.questions.question3.span = "";
        state.questions.question3.value = "";
        state.questions.question3.clickedYes = false;
        state.questions.question3.clickedNo = false;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question2.clickedNo = true;
        state.questions.question2.clickedYes = false;
        state.questions.question2.disabled = true;
      }
      state.questions.question2.value = data;
      state.questions.question2.clickedNo = true;
      state.questions.question2.clickedYes = false;
      state.questions.question2.disabled = true;
    },
    SEND_YES_QUESTION3(state, data) {
      if (state.questions.question3.value === "NO") {
        state.questions.question3.value = data;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question3.clickedYes = true;
        state.questions.question3.clickedNo = false;
        state.questions.question3.disabled = true;
      }
      state.questions.question3.value = data;
      state.questions.question3.clickedYes = true;
      state.questions.question3.clickedNo = false;
      state.questions.question3.disabled = true;
    },
    SEND_NO_QUESTION3(state, data) {
      if (state.questions.question3.value === "YES") {
        state.questions.question3.value = data;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.value = "";
        state.questions.question8.span = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question3.clickedNo = true;
        state.questions.question3.clickedYes = false;
        state.questions.question3.disabled = true;
      }
      state.questions.question3.value = data;
      state.questions.question3.clickedNo = true;
      state.questions.question3.clickedYes = false;
      state.questions.question3.disabled = true;
    },
    SEND_YES_QUESTION4(state, data) {
      if (state.questions.question4.value === "NO") {
        state.questions.question4.value = data;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question4.clickedYes = true;
        state.questions.question4.clickedNo = false;
        state.questions.question4.disabled = true;
      }
      state.questions.question4.value = data;
      state.questions.question4.clickedYes = true;
      state.questions.question4.clickedNo = false;
      state.questions.question4.disabled = true;
    },
    SEND_NO_QUESTION4(state, data) {
      if (state.questions.question4.value === "YES") {
        state.questions.question4.value = data;
        state.questions.question5.question = "";
        state.questions.question5.span = "";
        state.questions.question5.value = "";
        state.questions.question5.clickedYes = false;
        state.questions.question5.clickedNo = false;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question4.clickedNo = true;
        state.questions.question4.clickedYes = false;
        state.questions.question4.disabled = true;
      }
      state.questions.question4.value = data;
      state.questions.question4.clickedNo = true;
      state.questions.question4.clickedYes = false;
      state.questions.question4.disabled = true;
    },
    SEND_YES_QUESTION5(state, data) {
      if (state.questions.question5.value === "NO") {
        state.questions.question5.value = data;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question5.clickedYes = true;
        state.questions.question5.clickedNo = false;
        state.questions.question5.disabled = true;
      }
      state.questions.question5.value = data;
      state.questions.question5.clickedYes = true;
      state.questions.question5.clickedNo = false;
      state.questions.question5.disabled = true;
    },
    SEND_NO_QUESTION5(state, data) {
      if (state.questions.question5.value === "YES") {
        state.questions.question6.value = data;
        state.questions.question6.question = "";
        state.questions.question6.span = "";
        state.questions.question6.value = "";
        state.questions.question6.clickedYes = false;
        state.questions.question6.clickedNo = false;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question5.clickedNo = true;
        state.questions.question5.clickedYes = false;
        state.questions.question5.disabled = true;
      }
      state.questions.question5.value = data;
      state.questions.question5.clickedNo = true;
      state.questions.question5.clickedYes = false;
      state.questions.question5.disabled = true;
    },
    SEND_YES_QUESTION6(state, data) {
      if (state.questions.question6.value === "NO") {
        state.questions.question6.value = data;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question6.clickedYes = true;
        state.questions.question6.clickedNo = false;
        state.questions.question6.disabled = true;
      }
      state.questions.question6.value = data;
      state.questions.question6.clickedYes = true;
      state.questions.question6.clickedNo = false;
      state.questions.question6.disabled = true;
    },
    SEND_NO_QUESTION6(state, data) {
      if (state.questions.question6.value === "YES") {
        state.questions.question7.value = data;
        state.questions.question7.question = "";
        state.questions.question7.span = "";
        state.questions.question7.value = "";
        state.questions.question7.clickedYes = false;
        state.questions.question7.clickedNo = false;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question6.clickedNo = true;
        state.questions.question6.clickedYes = false;
        state.questions.question6.disabled = true;
      }
      state.questions.question6.value = data;
      state.questions.question6.clickedNo = true;
      state.questions.question6.clickedYes = false;
      state.questions.question6.disabled = true;
    },
    SEND_YES_QUESTION7(state, data) {
      if (state.questions.question7.value === "NO") {
        state.questions.question7.value = data;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question7.clickedYes = true;
        state.questions.question7.clickedNo = false;
        state.questions.question7.disabled = true;
      }
      state.questions.question7.value = data;
      state.questions.question7.clickedYes = true;
      state.questions.question7.clickedNo = false;
      state.questions.question7.disabled = true;
    },
    SEND_NO_QUESTION7(state, data) {
      if (state.questions.question7.value === "YES") {
        state.questions.question7.value = data;
        state.questions.question8.question = "";
        state.questions.question8.span = "";
        state.questions.question8.value = "";
        state.questions.question8.clickedYes = false;
        state.questions.question8.clickedNo = false;
        state.result = "";
        state.questions.question7.clickedNo = true;
        state.questions.question7.clickedYes = false;
        state.questions.question7.disabled = true;
      }
      state.questions.question7.value = data;
      state.questions.question7.clickedNo = true;
      state.questions.question7.clickedYes = false;
      state.questions.question7.disabled = true;
    },
    SEND_YES_QUESTION8(state, data) {
      state.questions.question8.value = data;
      state.questions.question8.clickedYes = true;
      state.questions.question8.clickedNo = false;
      state.questions.question8.disabled = true;
    },
    SEND_NO_QUESTION8(state, data) {
      state.questions.question8.value = data;
      state.questions.question8.clickedNo = true;
      state.questions.question8.clickedYes = false;
      state.questions.question8.disabled = true;
    },
    ANALYZE_QUESTION1(state) {
      if (state.questions.question1.value === "YES") {
        state.questions.question2.question =
          "La patiente a-t-elle eu/a un Cancer du sein ?";
        state.questions.question2.span =
          "(Antécédents ou en cours de traitement)";
      }
      if (state.questions.question1.value === "NO") {
        state.questions.question2.question =
          "La patiente est-elle agée de plus de 35 ans ? ";
      }
    },
    ANALYZE_QUESTION2(state) {
      if (
        state.questions.question1.value === "NO" &&
        state.questions.question2.value === "YES"
      ) {
        state.questions.question3.question =
          "L'IMC de la patiente est-il supérieur à 30 ?";
      }
      if (
        state.questions.question1.value === "NO" &&
        state.questions.question2.value === "NO"
      ) {
        state.questions.question3.question =
          "L'IMC de la patiente est-il supérieur à 30 ?";
      }
      if (
        state.questions.question1.value === "YES" &&
        state.questions.question2.value === "YES"
      ) {
        state.result = "DIU cuivre";
      }
      if (
        state.questions.question1.value === "YES" &&
        state.questions.question2.value === "NO"
      ) {
        state.result =
          "DIU hormonal, Implant, Pilule microprogestative, DIU cuivre ";
      }
    },
    ANALYZE_QUESTION3(state) {
      if (
        state.questions.question1.value === "NO" &&
        state.questions.question2.value === "YES" &&
        state.questions.question3.value === "YES"
      ) {
        state.questions.question4.question =
          "La patiente a-t-elle eu/a un Cancer du sein ?";
        state.questions.question4.span =
          "(Antécédents ou en cours de traitement)";
      } else {
        state.questions.question4.question = "La patiente fume-t-elle ?";
      }
    },
    ANALYZE_QUESTION4(state) {
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "YES")
      ) {
        state.questions.question5.question =
          "La patiente a-t-elle eu/a un Cancer du sein ?";
        state.questions.question5.span =
          "(Antécédents ou en cours de traitement)";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO")
      ) {
        state.questions.question5.question =
          "La patiente ou quelqu'un de sa famille proche présente-t-il une lipidémie élevée ?";
      }
      if (
        state.questions.question1.value === "NO" &&
        state.questions.question2.value === "YES" &&
        state.questions.question3.value === "YES" &&
        state.questions.question4.value === "YES"
      ) {
        state.result = "DIU cuivre";
      }
      if (
        state.questions.question1.value === "NO" &&
        state.questions.question2.value === "YES" &&
        state.questions.question3.value === "YES" &&
        state.questions.question4.value === "NO"
      ) {
        state.result =
          "DIU hormonal, Implant, Pilule microprogestative, DIU cuivre ";
      }
    },
    ANALYZE_QUESTION5(state) {
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "YES")
      ) {
        state.result = "DIU cuivre";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO")
      ) {
        state.result =
          "DIU hormonal, Implant, Pilule microprogestative, DIU cuivre ";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO")
      ) {
        state.questions.question6.question =
          "La patiente a-t-elle des migraines ?";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "YES") // OK
      ) {
        state.questions.question6.question =
          "La patiente a-t-elle eu/a un Cancer du sein?";
        state.questions.question6.span =
          "(Antécédents ou en cours de traitement)";
      }
    },
    ANALYZE_QUESTION6(state) {
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "YES")
      ) {
        state.result = "DIU cuivre";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO")
      ) {
        state.result =
          "DIU hormonal, Implant, Pilule microprogestative, DIU cuivre ";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO")
      ) {
        state.questions.question7.question =
          "La patiente est-elle diabétique ?";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO")
      ) {
        state.result =
          "DIU hormonal, Implant, Pilule microprogestative, DIU cuivre ";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "YES") // OK
      ) {
        state.questions.question7.question =
          "La patiente a-t-elle eu/a un Cancer du sein?";
        state.questions.question7.span =
          "(Antécédents ou en cours de traitement)";
      }
    },
    ANALYZE_QUESTION7(state) {
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "YES") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "YES")
      ) {
        state.result = "DIU cuivre";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "NO")
      ) {
        state.result =
          "DIU hormonal, Implant, Pilule microprogestative, DIU cuivre ";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO") || //OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "NO") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO") // OK
      ) {
        state.questions.question8.question =
          "La patiente a-t-elle eu/a un Cancer du sein?";
        state.questions.question8.span =
          "(Antécédents ou en cours de traitement)";
      }
    },
    ANALYZE_QUESTION8(state) {
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "YES") // OK
      ) {
        state.result = "DIU cuivre";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "NO") // OK
      ) {
        state.result =
          "DIU hormonal, Implant, Pilule microprogestative, DIU cuivre ";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "YES") || // OK
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "YES") // OK
      ) {
        state.result = "DIU cuivre";
      }
      if (
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "YES" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "YES" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "YES" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "YES" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "YES" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "YES" &&
          state.questions.question8.value === "NO") ||
        (state.questions.question1.value === "NO" &&
          state.questions.question2.value === "NO" &&
          state.questions.question3.value === "NO" &&
          state.questions.question4.value === "NO" &&
          state.questions.question5.value === "NO" &&
          state.questions.question6.value === "NO" &&
          state.questions.question7.value === "NO" &&
          state.questions.question8.value === "NO")
      ) {
        state.result = "Toutes les contraceptions sont possibles";
      }
    },
    RESET_STATE(state) {
      state.questions = {
        question1: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question2: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question3: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question4: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question5: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question6: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question7: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question8: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
      };
      state.result = "";
    },
    ARROW_TRUE(state) {
      state.arrow = true;
    },
    ARROW_FALSE(state) {
      state.arrow = false;
    },
  },
};

export default Algo1Module; // export the module
